import { AddOffer, Commission, CommissionOffer, CommissionRates, CommissionType, DurationOffer, MDRValues, PromoCommission } from './proposal-lists';
export class ProposalCreation {
    public static PickupCommissionList: Array<Commission> = [
        {
            name: CommissionType.Starter,
            mdr: MDRValues.Starter,
            commissionRate: CommissionRates.Starter,
            custom:'',
        },
        {
            name: CommissionType.Growth,
            mdr: MDRValues.Growth,
            commissionRate: CommissionRates.Growth,
            custom:'',
        },
        {
            name: CommissionType.Elite,
            mdr: MDRValues.Elite,
            commissionRate: CommissionRates.Elite,
            custom:'',
        },
        {
            name: CommissionType.Custom,
            mdr: MDRValues.Custom,
            commissionRate: CommissionRates.Custom,
            custom:'',
        },
    ];

    public static DeliveryCommissionList: Array<Commission> = [
        {
            name: CommissionType.Starter,
            mdr: MDRValues.Starter,
            commissionRate: CommissionRates.Starter,
            custom:'',
        },
        {
            name: CommissionType.Growth,
            mdr: MDRValues.Growth,
            commissionRate: CommissionRates.Growth,
            custom:'',
        },
        {
            name: CommissionType.Elite,
            mdr: MDRValues.Elite,
            commissionRate: CommissionRates.Elite,
            custom:'',
        },
        {
            name: CommissionType.Custom,
            mdr: MDRValues.Custom,
            commissionRate: CommissionRates.Custom,
            custom:'',
        },
      ];

      public static PromoOfferList: Array<PromoCommission> = [
        {
            name: CommissionType.None,
            commissionOffer: 0,
            duration: '',
            advertising: ''
        },
        {
            name: CommissionType.Starter,
            commissionOffer: CommissionOffer.Starter,
            duration: DurationOffer.Starter,
            advertising: AddOffer.Starter
        },
        {
            name: CommissionType.Growth,
            commissionOffer: CommissionOffer.Growth,
            duration: DurationOffer.Growth,
            advertising: AddOffer.Growth
        },
        {
            name: CommissionType.Elite,
            commissionOffer: CommissionOffer.Elite,
            duration: DurationOffer.Elite,
            advertising: AddOffer.Elite
        },
        {
            name: CommissionType.Custom,
            commissionOffer: CommissionOffer.Custom,
            duration: AddOffer.Custom,
            advertising: AddOffer.Custom
        },
    ];
}
